import { INPUT_BORDER_RADIUS, INPUT_WIDTH } from '../theme/constants';

const styleOverrides = {
  root: {
    minWidth: INPUT_WIDTH['MEDIUM'],
    borderRadius: INPUT_BORDER_RADIUS,
  },
};

export default styleOverrides;
